// app/javascript/controllers/datepicker_controller.js
import { Controller } from "@hotwired/stimulus"
import { easepick, LockPlugin, TimePlugin } from "@easepick/bundle"

export default class extends Controller {
    static values = {
        minDate: String,      // optional override
        allowPast: Boolean,   // new: opt-in to allow past dates
    }

    getTodayDateString() {
        const t = new Date()
        const y = t.getFullYear()
        const m = String(t.getMonth() + 1).padStart(2, "0")
        const d = String(t.getDate()).padStart(2, "0")
        return `${y}-${m}-${d}`
    }

    connect() {
        if (typeof easepick === "undefined") {
            console.error("Easepick not loaded.")
            return
        }

        // Determine minDate (undefined => no minimum)
        const minDate =
            (this.hasAllowPastValue && this.allowPastValue)
                ? undefined
                : (this.hasMinDateValue ? this.minDateValue : this.getTodayDateString())

        const pickerOptions = {
            element: this.element,
            css: [
                "https://cdn.jsdelivr.net/npm/@easepick/bundle@1.2.1/dist/index.css",
                "https://cdn.jsdelivr.net/npm/@easepick/time-plugin@1.2.1/dist/index.css",
            ],
            zIndex: 9999,
            customClass: "echo-datepicker-theme",
            position: "top",
            plugins: [LockPlugin, TimePlugin],
            LockPlugin: {},
            TimePlugin: { format: "HH:mm" },
            setup: (picker) => {
                picker.on("select", () => this.triggerValidation())
            },
        }

        // Only set minDate when we actually want to lock past dates
        if (minDate !== undefined) {
            pickerOptions.LockPlugin.minDate = minDate
        }

        this.picker = new easepick.create(pickerOptions)
    }

    triggerValidation() {
        const evt = new Event("input", { bubbles: true })
        this.element.dispatchEvent(evt)
    }

    disconnect() {
        this.picker?.destroy()
    }
}